import resume from '../assets/pdf/resume.pdf'

export const headerData = {
    name: 'Raghvendra Shri',
    title: "Problem Solver",
    desciption: "You never change things by fighting the existing reality. To change something, build a new model that makes the existing model obsolete.",
    image: 'https://avatars.githubusercontent.com/u/10459999?v=4',
    resumePdf: resume
}
